import { EditOutlined as EditOutlinedIcon } from '@mui/icons-material';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import type { SecondaryActionProps } from '../../../design/components/button/SecondaryAction';
import { SecondaryActionButton } from '../../../design/components/button/SecondaryAction';

type EditButtonProps = Omit<SecondaryActionProps, 'label' | 'startIcon'>;

export const EditButton: FunctionComponent<EditButtonProps> = ({ onClick, ...props }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <SecondaryActionButton
            aria-label="Edit"
            label={translate('common.edit')}
            startIcon={<EditOutlinedIcon color="action" />}
            onClick={onClick}
            {...props}
        />
    );
};
